import { module } from 'modujs';
// import { SplitText } from '../gsap'
import Splitting from 'splitting'
import { EAGER_FONTS } from '../app';
import { whenReady } from '../utils/fonts';

export default class AnimText extends module {

    static get settings() {
        return {
            CLASSNAME: 'o-anim-text',
            SPLIT_TYPES: {
                block: {
                    splitType: false,
                    class: '-block'
                },
                lines: {
                    splitType: 'lines',
                    class: '-lines'
                },
            },
        }
    }

    constructor(m) {
        super(m);

        this.$el = this.el

        // Define animation type
        const type = this.getData('type') || 'lines' // lines by default
        this.TYPE = AnimText.settings.SPLIT_TYPES[type]
    }

    init() {

        this.$el.classList.add(AnimText.settings.CLASSNAME)

        // Hidden text per default
        this.isActive = true

        // No split as default
        this.splitType = this.TYPE.splitType
        this.$el.classList.add(this.TYPE.class)

        if(this.splitType) {
            this.$el.setAttribute('aria-label', this.$el.innerText)

            this.$split = document.createElement('div')
            this.$split.innerHTML = this.$el.innerHTML
            this.$split.setAttribute('aria-hidden', 'true')
            this.$el.innerHTML = ''
            this.$el.appendChild(this.$split)
        } else {
            this.$split = this.$el
        }

        whenReady(EAGER_FONTS).then(() => {
            // Split lines
            this.initSplits()

            // // Resize event
            // window.addEventListener('resizeEnd', this.onResize = () => this.resize())
        })
    }

    initSplits() {

        if(!this.splitType) {
            return
        }

        // Split text
        this.split = Splitting({ target: this.$split, by: this.splitType })

        let wordIndex = 0
        const $words = this.split[0].words

        while (wordIndex < $words.length) {
            const $word = $words[wordIndex]
            const content = $word.innerHTML;
            const wrapper = `<span class="word_inner">${content}</span>`
            $word.innerHTML = wrapper
            wordIndex++
        }

        // this.split = new SplitText(this.$split, {
        //     type: this.splitType,
        //     linesClass: `${AnimText.settings.CLASSNAME}_line`,
        //     wordsClass: `${AnimText.settings.CLASSNAME}_word`,
        //     charsClass: `${AnimText.settings.CLASSNAME}_char`,
        // })

        // // Lines
        // const lineCount = this.split.lines.length
        // if(lineCount > 0) {
        //     this.$el.style.setProperty('--anim-text-line-count', lineCount)
        //     this.split.lines.forEach(($line, i) => {
        //         $line.style.setProperty('--anim-text-line-index', i)
        //     })
        // }

        // // Chars
        // const charCount = this.split.chars.length
        // let maxCharPerLine = 0
        // if(charCount > 0) {
        //     this.split.lines.forEach(($line, i) => {
        //         let char = 0
        //         $line.querySelectorAll(`.${AnimText.settings.CLASSNAME}_char`).forEach(($char, j) => {
        //             $char.style.setProperty('--anim-text-char-index', j)
        //             char++
        //             maxCharPerLine = Math.max(maxCharPerLine, char)
        //         })
        //     })
        //     this.$el.style.setProperty('--anim-text-char-count', maxCharPerLine)
        // }

    }

    // revertSplits() {
    //     if(!this.splitType) return

    //     this.split.revert()
    // }

    // resize() {

    //     if(!this.isActive) {
    //         return
    //     }

    //     if(this.splitType) {
    //         this.revertSplits()
    //         this.initSplits()
    //     }
    // }

    // endReveal() {
    //     this.isActive = false

    //     setTimeout(() => {
    //         this.revertSplits()

    //         window.removeEventListener('resizeEnd', this.onResize)
    //     }, 2000);
    // }

    destroy() {
        if(this.isActive) {
            window.removeEventListener('resizeEnd', this.onResize)
        }
    }
}
